<div class="relative flex min-w-0 justify-center" (keydown.escape)="close()">
  <button
    #triggerButton
    type="button"
    [id]="id()"
    [attr.aria-label]="caption() ? null : label() || null"
    [attr.aria-expanded]="opened()"
    [attr.aria-controls]="opened() ? `${id()}-options` : null"
    [tooltip]="tooltipText()"
    [visibleTooltip]="!!tooltipText()"
    [position]="TooltipPosition.BELOW"
    class="search-bar-button inline-flex items-center gap-1 rounded-lg px-2 py-1 bg-neutrals-white!"
    [ngClass]="{ 'opened': opened(), 'filtersApplied border-primary-purple-light': selected().length > 0, 'cursor-not-allowed opacity-50': disabled() }"
    (click)="toggle()"
  >
    <img [src]="icon()" alt="" class="h-5 w-5 filter-primary-purple-light" />
    @if (caption()) {
      <span class="truncate text-base font-semibold">{{ caption() }}</span>
    }
    @if (selected().length > 0) {
      <span class="font-bold text-primary-purple-light text-[14px]">({{ selected().length }})</span>
    } @else {
      <img [src]="images.arrowDown" alt="" class="h-3 w-3 transition-transform filter-neutrals-grey-04" [ngClass]="{ 'rotate-180': opened() }" />
    }
  </button>
  @if (opened()) {
    <section [id]="`${id()}-options`" class="absolute left-0 top-full z-40 mt-2 flex w-max flex-col rounded-[10px] bg-white p-1.5 shadow border border-neutrals-grey-01">
      @if (searchable()) {
        <div class="mb-1.5 h-9">
          <app-input-search [placeholder]="literalService.get('search', true)" [width]="'full'" [style]="'secondary'" [compact]="true" (valueChangeEventEmitter)="searchTerms.next($event)" (submitEventEmitter)="searchTerms.next($event)" />
        </div>
      }
      <article class="flex max-h-60 w-0 min-w-full flex-col overflow-y-auto" (scroll)="onScroll($event)">
        @if (loading) {
          @for (row of skeletonRows; track $index) {
            <ng-container [ngTemplateOutlet]="skeletonRow" />
          }
        } @else {
          @for (option of options; track option.id) {
            @let isOptionChecked = isChecked(option);
            <div
              class="py-2"
              [ngClass]="{
                'bg-primary-purple-light-2-selected': isOptionChecked,
                'rounded-t': isOptionChecked && $first,
                'rounded-b': isOptionChecked && $index === checkedCount - 1
              }"
            >
              <label class="flex items-center gap-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300 cursor-pointer">
                <input [id]="`${id()}-checkbox-${option.id}`" type="checkbox" class="cursor-pointer shrink-0" [class]="isOptionChecked ? 'bg-primary-purple-light!' : ''" [checked]="isOptionChecked" (change)="toggleOption(option)">
                @if (option.icon) {
                  <img [src]="option.icon.src" alt="" aria-hidden="true" class="h-5 w-5 shrink-0" [class]="option.icon.filterClass" />
                }
                <span
                    class="truncate"
                    [ngClass]="{'text-primary-purple-light': isOptionChecked}"
                    [id]="`${id()}-option-${option.id}`"
                    [tooltip]="option.tooltip || option.label"
                    [position]="TooltipPosition.DYNAMIC"
                    [visibleTooltip]="!!option.tooltip || utilsService.visibleTooltip(`${id()}-option-${option.id}`)"
                >
                    {{ option.label }}
                </span>
              </label>
            </div>
          } @empty {
            <span class="text-sm text-neutrals-grey-04 py-8">{{ literalService.get('bookings.noResults', true) }}</span>
          }
          @if (loadingMore) {
            <ng-container [ngTemplateOutlet]="skeletonRow" />
          }
        }
      </article>
      <ng-template #skeletonRow>
        <div class="flex items-center gap-2 ml-2 py-2">
          <ngx-skeleton-loader class="flex shrink-0" count="1" appearance="square" size="18" [theme]="{ 'margin': '0', 'border-radius': '4px' }" />
          <ngx-skeleton-loader class="flex flex-1" count="1" appearance="line" [theme]="{ 'height': '14px', 'width': '100%', 'margin-bottom': '0' }" />
        </div>
      </ng-template>
      <div class="divider m-0 w-[90%] h-2 self-center"></div>
      <footer class="flex justify-around gap-2 py-1.5">
        <button type="button" class="btn btn-sm btn-ghost text-secondary-red font-normal!" (click)="clean()">{{ literalService.get('clear', true) }}</button>
        <button type="button" class="btn btn-sm bg-primary-purple text-neutrals-white min-w-16! rounded-md! py-2" (click)="applySelection()">{{ literalService.get('apply', true) }}</button>
      </footer>
    </section>
  }
</div>
